import { Box, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import { useChangeOrganizationProcess } from '../../hooks/useChangeOrganizationProcess.hook'
import { OrganizationSelector } from '../OrganizationSelector/OrganizationSelector.component'

const OrganizationSelectorModal = () => {
  const { handleChangeOrganization, isChanging } =
    useChangeOrganizationProcess()

  return (
    <Box mb="xs">
      <Text size="md" c="dimmed">
        Choose an organization to continue
      </Text>
      <OrganizationSelector
        testIdFeature="organization-selector"
        onChange={handleChangeOrganization}
        disabled={isChanging}
      />
    </Box>
  )
}

export const organizationSelectorModal = () =>
  modals.open({
    title: (
      <Text fw="bold" size="xl">
        Switch Organization
      </Text>
    ),
    centered: true,
    children: <OrganizationSelectorModal />,
    size: 'md',
    radius: 'md',
  })
